import React from "react";
import { motion } from "framer-motion";

const ProcedurePlaceholder = ({
  procedureName,
  icon,
  size = "hero",
  imageSrc,
  imageAlt,
}) => {
  const isHero = size === "hero";

  if (imageSrc) {
    const height = isHero ? 480 : 220;
    return (
      <motion.div
        className="w-full overflow-hidden rounded-xl border border-[rgba(168,137,92,0.25)] bg-deep-navy/5"
        style={{ maxWidth: "100%" }}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.15 }}
      >
        <motion.img
          src={imageSrc}
          alt={imageAlt || procedureName || "Procedure"}
          className="w-full object-cover"
          style={{ height }}
          loading="lazy"
          initial={{ scale: 1.06 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.4, ease: "easeOut" }}
        />
      </motion.div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        height: isHero ? "320px" : "220px",
        background: "linear-gradient(135deg, #FAFAF8 0%, #EDE8E0 100%)",
        border: "1px solid rgba(168, 137, 92, 0.25)",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        padding: "32px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "12px",
          left: "12px",
          width: "20px",
          height: "20px",
          borderTop: "2px solid rgba(168,137,92,0.4)",
          borderLeft: "2px solid rgba(168,137,92,0.4)",
          borderRadius: "2px 0 0 0",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "12px",
          right: "12px",
          width: "20px",
          height: "20px",
          borderTop: "2px solid rgba(168,137,92,0.4)",
          borderRight: "2px solid rgba(168,137,92,0.4)",
          borderRadius: "0 2px 0 0",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "12px",
          left: "12px",
          width: "20px",
          height: "20px",
          borderBottom: "2px solid rgba(168,137,92,0.4)",
          borderLeft: "2px solid rgba(168,137,92,0.4)",
          borderRadius: "0 0 0 2px",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "12px",
          right: "12px",
          width: "20px",
          height: "20px",
          borderBottom: "2px solid rgba(168,137,92,0.4)",
          borderRight: "2px solid rgba(168,137,92,0.4)",
          borderRadius: "0 0 2px 0",
        }}
      />

      <div
        style={{
          width: isHero ? "72px" : "56px",
          height: isHero ? "72px" : "56px",
          borderRadius: "50%",
          background: "rgba(42, 53, 69, 0.06)",
          border: "1px solid rgba(168, 137, 92, 0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: isHero ? "32px" : "24px",
        }}
      >
        {icon}
      </div>

      <div style={{ textAlign: "center" }}>
        <p
          style={{
            color: "#2A3545",
            fontSize: isHero ? "15px" : "13px",
            fontWeight: "600",
            letterSpacing: "0.5px",
            marginBottom: "6px",
          }}
        >
          {procedureName}
        </p>
        <p
          style={{
            color: "rgba(42,53,69,0.45)",
            fontSize: "11px",
            letterSpacing: "1px",
            textTransform: "uppercase",
          }}
        >
          Results gallery coming soon
        </p>
      </div>
    </div>
  );
};

export default ProcedurePlaceholder;
